import { Observable } from 'rxjs'
import { map, pluck, tap } from 'rxjs/operators'

import { Item, Wemi } from '@skinsoft/types'
import { itemSelectors, wemiSelectors } from '@skinsoft/selectors'
import { OfflineDataFetcher } from '@skinsoft/offline'
import { matchesRegex } from '@skinsoft/utils'

export type WemiOfflineDataFetcher = ItemOfflineDataFetcher;

// @ts-ignore
export class ItemOfflineDataFetcher extends OfflineDataFetcher<Item, Wemi>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    /*public fetchWemiFromId(id: string): Observable<Wemi> {
        return WemiUtils.getWemiFromItem(id);
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.item) {
            return entity.item.id === id;
        }
        return false;
    }

    protected async queryTextFilter(entity: Wemi | Item, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        const isWemi: boolean = "item" in entity && "manifestation" in entity && "expression" in entity && "work" in entity

        let titleMatch: boolean
        let identifierMatch: boolean
        if(isWemi) {
            // item title match 
            const title: string = wemiSelectors.title(entity as Wemi, locale);
            titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false;

            // item identifier match
            const identifier: string = wemiSelectors.inventoryNumber(entity as Wemi, locale);
            identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false;
        } else {
            // item title match 
            const title: string = itemSelectors.title(entity as Item, locale);
            titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false;

            // item identifier match
            const identifier: string = itemSelectors.inventoryNumber(entity as Item);
            identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false;
        }

        return titleMatch || identifierMatch;
    }
}